import { LOWEST_HIGHEST_WASH_COUNT_SUCCESS, LOWEST_HIGHEST_WASH_COUNT_FAILURE } from '../constants/MTag';
import { onSuccess, onFailure } from './common';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
	switch (action.type) {
		case LOWEST_HIGHEST_WASH_COUNT_SUCCESS:
			return onSuccess(state, action);
		case LOWEST_HIGHEST_WASH_COUNT_FAILURE:
			return onFailure(state, action);
		default:
			return { ...state };
	}
};
